// extracted by mini-css-extract-plugin
export var box = "_8n-1";
export var checked = "_8n-2";
export var descriptionSpacer = "_8n-9";
export var disabled = "_8n-3";
export var icon = "_8n-6";
export var input = "_8n-0";
export var labelSpacer = "_8n-8";
export var medium = "_8n-5";
export var small = "_8n-4";
export var text = "_8n-7";